import React, { Suspense, lazy } from "react"
import { Route, Routes, useLocation } from "react-router-dom"

import Header from "shared/components/Header"

const CheckoutHeader = lazy(() => import("shared/components/Header/Checkout"))
const SignUpHeader = lazy(() => import("shared/components/Header/SignUp"))

export default function HeadersRoutes(props) {
  const { userName, stateReady } = props
  const location = useLocation()
  return (
    <Routes location={location}>
      <Route
        path="/*"
        element={<Header stateReady={stateReady} name={userName} />}
      />
      <Route
        path="/checkout/:plan/*"
        element={
          <Suspense fallback={<Header />}>
            <CheckoutHeader />
          </Suspense>
        }
      />

      <Route
        path="/v3/checkout/*"
        element={
          <Suspense fallback={<Header />}>
            <CheckoutHeader />
          </Suspense>
        }
      />

      <Route
        path="/sign-up"
        element={
          <Suspense fallback={<Header />}>
            <SignUpHeader />
          </Suspense>
        }
      />
      <Route
        path="/start"
        element={
          <Suspense fallback={<Header />}>
            <SignUpHeader />
          </Suspense>
        }
      />
    </Routes>
  )
}
